import { Group, Text } from '@melio/penny';
import { useMelioIntl } from '@melio/platform-i18n';

type SubscriptionCheckoutBillingTotalProps = {
  subTotal: number;
};

export const SubscriptionCheckoutBillingTotal = ({ subTotal }: SubscriptionCheckoutBillingTotalProps) => {
  const { formatMessage, formatCurrency } = useMelioIntl();

  return (
    <Group justifyContent="space-between" alignItems="flex-start">
      <Text textStyle="body2Semi">{formatMessage('activities.subscription.checkout.summary.subTotal')}</Text>
      <Text textStyle="body1Semi" data-testid="subscription-checkout-subtotal">
        {formatCurrency(subTotal)}
      </Text>
    </Group>
  );
};
